import React from 'react'
import {
  Button,
  Spacer,
  Text,
  Anchor,
  Flex,
  Transition,
  Icon,
  Div,
} from '@sendoutcards/quantum-design-ui'
import { useActions, useState } from 'src/hooks'
import { useUnlockAccountSendCode } from 'src/react_query/mutations/hooks'
import { UnlockAccountStatusCode } from 'src/graphql/generated/graphql'

type Props = {
  username: string
}
export const UnlockWithPhone = (props: Props) => {
  const { username } = props
  const { mutate, isLoading, error, data } = useUnlockAccountSendCode()
  const [failureMsg, setFailureMsg] = useState<string | null>(null)
  const actions = useActions()

  const handleSendCode = () => {
    mutate(
      { username },
      {
        onSuccess: data => {
          const result = data.unlockAccountSendCode
          const basePath = `/unlock-account/${username}`
          if (
            result.statusCode === UnlockAccountStatusCode.SentPhoneVerification
          ) {
            // Navigate to verify code route
            let path = `${basePath}/verify-code`
            if (result.sentTo) {
              path += `?sentTo=${encodeURIComponent(result.sentTo)}`
            }
            window.location.href = path
          } else if (
            result.statusCode === UnlockAccountStatusCode.CallInRequired
          ) {
            // Navigate to call required route
            window.location.href = `${basePath}/call-required`
          } else {
            setFailureMsg(result.message ?? 'Failed to send verification code')
          }
        },
      },
    )
  }

  if (isLoading) {
    return <Transition isLoading={true} title="Sending verification code..." />
  }

  const errorMessage =
    failureMsg || (error instanceof Error ? error.message : 'An error occurred')

  return (
    <Flex flexDirection="column" alignItems="center" style={{ width: '100%' }}>
      {error || failureMsg ? (
        <>
          <Flex
            flexDirection="column"
            alignItems="center"
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: '#FEE2E2',
              borderRadius: '8px',
              border: '1px solid #FCA5A5',
            }}
          >
            <Text type="body" color="danger" alignment="center">
              {errorMessage}
            </Text>
          </Flex>
          <Spacer space="x3" />
          <Button
            onClick={() => {
              actions.openAccount()
            }}
            fullWidth
            size="large"
          >
            Back to Login
          </Button>
        </>
      ) : data?.unlockAccountSendCode.success ? (
        <Div
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Icon name="squareCheck" size={48} primaryColor="success" />
          <Text type="body">Successfully sent Code </Text>
        </Div>
      ) : (
        <Button onClick={handleSendCode} fullWidth size="large">
          Send Verification Code
        </Button>
      )}
      <Spacer space="x3" />
      <Text type="caption" alignment="center">
        Need help?
      </Text>
      <Spacer space="x1" />
      <Anchor
        title="Contact Customer Support"
        isDecorated={true}
        onClick={() => {
          window.open('tel:1-800-463-3800', '_self')
        }}
      />
    </Flex>
  )
}
